export const branchedComponent = (componentsMap) => {
  const branch = process.env.REACT_APP_BRANCH;
  if (!branch) {
    throw "Unknown branch";
  }
  return componentsMap[branch];
}